import apiFetch from '../../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Visita/editVisita`, method: 'POST', body: values, token: token})
}
